import { css } from 'lit';

export const styles = css`
  li {
    cursor: pointer;
    display: flex;
    padding: 0.5rem;
    box-sizing: border-box;
    text-align: left;
    text-overflow: ellipsis;
    text-wrap: nowrap;
    align-items: center;
    gap: 0.25rem;
    max-width: 100%;
    width: 100%;
    overflow-y: visible;
    flex: 1;

    input[type='checkbox'] {
      width: var(--checkbox-size, var(--space-scale-2));
      aspect-ratio: 1;
      flex: 0 0 auto;
      accent-color: var(--color-primary-400);
      pointer-events: none;
    }

    span {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      flex: 1;
      line-height: 1.1;
    }

    &[aria-hidden='true'] {
      visibility: hidden;
      display: none;
    }

    &[aria-disabled='true'] {
      pointer-events: none;
      opacity: 0.5;
    }

    &[aria-selected='true']:not(:has(input[type='checkbox'])) {
      color: var(--tt-combobox-option-selected-color, var(--color-primary-400));
      font-weight: var(--font-weight-medium);
    }
  }

  :host([active]),
  :host(:hover) {
    li {
      background-color: var(--tt-combobox-option-background-color-hover, var(--color-surface-300));
      color: var(--tt-combobox-option-color-hover, inherit);
    }

    &:first-child li {
      border-top-left-radius: var(--border-radius);
      border-top-right-radius: var(--border-radius);
    }

    &:last-child li {
      border-bottom-left-radius: var(--border-radius);
      border-bottom-right-radius: var(--border-radius);
    }
  }

  :host([disabled]) {
    pointer-events: none;
  }
`;
